/* PANDRUM — LowDesign Top · audio + sticky CTA + sync prix avec variant-picker natif */
(function() {
  'use strict';

  /* ===== Helpers prix : parse + format européen ===== */
  function parseMoney(text) {
    if (!text) return 0;
    var clean = String(text).replace(/[^\d,\.]/g, '');
    if (!clean) return 0;
    var lastComma = clean.lastIndexOf(',');
    var lastPeriod = clean.lastIndexOf('.');
    var num;
    if (lastComma > lastPeriod) {
      // EU : . = milliers, , = décimal (ex. 1.133,90)
      num = parseFloat(clean.replace(/\./g, '').replace(',', '.'));
    } else if (lastPeriod > lastComma) {
      // US : , = milliers, . = décimal (ex. 1,133.90)
      num = parseFloat(clean.replace(/,/g, ''));
    } else {
      // un seul séparateur ou aucun
      num = parseFloat(clean.replace(',', '.'));
    }
    return isNaN(num) ? 0 : num;
  }

  function formatMoney(amount, sample) {
    sample = sample || '€0,00';
    var symbolMatch = sample.match(/[€$£¥₹]/);
    var symbol = symbolMatch ? symbolMatch[0] : '€';
    var firstDigit = sample.search(/\d/);
    var symbolPos = sample.indexOf(symbol);
    var symbolFirst = symbolPos !== -1 && (firstDigit === -1 || symbolPos < firstDigit);

    var sampleNum = sample.replace(/[^\d,\.]/g, '');
    var lastComma = sampleNum.lastIndexOf(',');
    var lastPeriod = sampleNum.lastIndexOf('.');
    var isEu = lastComma > lastPeriod || (lastComma === -1 && lastPeriod === -1);

    var rounded = Math.round(amount * 100) / 100;
    var formatted;
    if (rounded === Math.floor(rounded)) {
      // entier → pas de décimales (équivalent money_without_trailing_zeros)
      formatted = String(Math.floor(rounded));
    } else {
      formatted = rounded.toFixed(2);
    }

    if (isEu) {
      formatted = formatted.replace('.', ',');
      var partsEu = formatted.split(',');
      partsEu[0] = partsEu[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      formatted = partsEu.join(',');
    } else {
      var partsUs = formatted.split('.');
      partsUs[0] = partsUs[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      formatted = partsUs.join('.');
    }

    return symbolFirst ? symbol + formatted : formatted + ' ' + symbol;
  }

  document.querySelectorAll('.lowdesign-top').forEach(function(root) {

    /* --- Transformation des variantes natives ---
       1) Marque l'option Couleur pour CSS swatches (ronds avec image)
       2) Compte le nb d'options pour grille adaptative (3=>1L, 4=>2x2)
    */
    var variantsScript = root.querySelector('[data-ldt-variants]');
    var variantsData = [];
    try { variantsData = JSON.parse(variantsScript.textContent); } catch (e) {}

    function transformVariants() {
      root.querySelectorAll('.variant-picker__option').forEach(function(opt) {
        // Détecte le nom de l'option
        var nameEl = opt.querySelector('.variant-picker__option-name span, .variant-picker__option-name');
        var optionName = (nameEl ? nameEl.textContent : '').toLowerCase();
        var values = opt.querySelector('.variant-picker__option-values');
        if (!values) return;

        // Compte les options
        var count = values.children.length;
        values.setAttribute('data-count', count);

        // Si Couleur/Color : transforme en swatches image
        if (optionName.indexOf('couleur') !== -1 || optionName.indexOf('color') !== -1 || optionName.indexOf('colour') !== -1 || optionName.indexOf('farbe') !== -1 || optionName.indexOf('kleur') !== -1) {
          opt.classList.add('variant-picker__option--color');
          // Pour chaque radio, trouve la 1ère variante qui a cette valeur d'option et set son image
          values.querySelectorAll('input[type="radio"]').forEach(function(input) {
            var label = input.nextElementSibling;
            if (!label) return;
            var optionValue = input.value;
            // Trouve une variante qui a cette valeur ET une image
            var match = variantsData.find(function(v) {
              return v.options && v.options.indexOf(optionValue) !== -1 && v.image;
            });
            if (match && match.image) {
              label.style.backgroundImage = 'url(' + match.image + ')';
            }
          });
        }
      });
    }
    transformVariants();
    // Re-applique après chaque mise à jour du DOM (changement de variante recharge parfois le picker)
    if ('MutationObserver' in window) {
      var vp = root.querySelector('variant-picker');
      if (vp) {
        var voo = new MutationObserver(function() { transformVariants(); });
        voo.observe(vp, { childList: true, subtree: true });
      }
    }

    /* ===== FIX 4 — Pré-sélection par défaut : 9 notes + 432 Hz =====
       Si l'URL ne précise pas ?variant=, on cherche la variante recommandée
       débutant (9 notes + 432 Hz + 1ère couleur dispo) et on coche les radios.
       Si elle n'existe pas (ex: Mandala sans 9 notes), on laisse la sélection
       par défaut Shopify (1ère variante disponible).
       Couleur : on laisse Shopify gérer. */
    function preselectDefaultVariant() {
      try {
        if (new URLSearchParams(window.location.search).has('variant')) return false;
      } catch(e) { /* ignore */ }

      if (!variantsData || !variantsData.length) return false;

      // Patterns ouverts à droite (\\b) pour matcher "9 notes - Débutant" etc.
      var notesPatterns = [/^\s*9\s*notes?\b/i, /^\s*9\b/i, /initiation/i];
      var hzPatterns    = [/^\s*432\s*hz\b/i, /^\s*432\b/i];

      function matchAny(val, patterns) {
        if (val == null) return false;
        var s = String(val);
        for (var i = 0; i < patterns.length; i++) if (patterns[i].test(s)) return true;
        return false;
      }

      // Cherche une variante qui contient une option "9 notes" ET une option "432 Hz"
      var target = variantsData.find(function(v) {
        if (!v.options) return false;
        var hasNotes = v.options.some(function(o) { return matchAny(o, notesPatterns); });
        var hasHz    = v.options.some(function(o) { return matchAny(o, hzPatterns); });
        return hasNotes && hasHz;
      });
      if (!target) return false;

      var changed = false;
      var lastChanged = null;

      // Pour chaque option du variant cible, coche le radio correspondant
      // SAUF pour les couleurs (on laisse Shopify gérer)
      root.querySelectorAll('.variant-picker__option').forEach(function(opt) {
        var nameEl = opt.querySelector('.variant-picker__option-name span, .variant-picker__option-name');
        var optionName = (nameEl ? nameEl.textContent : '').toLowerCase();
        if (optionName.indexOf('couleur') !== -1 || optionName.indexOf('color') !== -1 || optionName.indexOf('colour') !== -1 || optionName.indexOf('farbe') !== -1 || optionName.indexOf('kleur') !== -1) {
          return; // laisser la couleur par défaut
        }

        var isNotes = /note|töne|toene|tonen/i.test(optionName);
        var isHz    = /hz|fr(é|e)quence|frequenz|frequentie/i.test(optionName);
        if (!isNotes && !isHz) return; // ignore les autres options éventuelles

        var patterns = isNotes ? notesPatterns : hzPatterns;
        var radios = opt.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          var r = radios[i];
          if (r.disabled || r.getAttribute('aria-disabled') === 'true') continue;
          if (matchAny(r.value, patterns)) {
            if (!r.checked) {
              r.checked = true;
              lastChanged = r;
              changed = true;
            }
            break;
          }
        }
      });

      // Dispatch un seul change event pour notifier Fullstack + déclencher updateLdtPrice()
      if (changed && lastChanged) {
        try {
          lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
        } catch(e) {
          var ev = document.createEvent('Event'); ev.initEvent('change', true, true);
          lastChanged.dispatchEvent(ev);
        }
      }
      return changed;
    }

    // Lance la pré-sélection une seule fois au chargement (après un micro-délai
    // pour laisser <variant-picker> finir son upgrade Custom Element).
    setTimeout(preselectDefaultVariant, 30);

    /* ===== FIX 5 — Helper exposé pour le quiz =====
       Permet au quiz d'auto-sélectionner notes + Hz quand sa recommandation
       correspond au produit en cours. Réutilise le même pattern de matching
       que preselectDefaultVariant. */
    function applyVariantSelectionByLabels(targetNotes, targetHz) {
      if (!targetNotes && !targetHz) return false;

      // Patterns ouverts à droite (\\b) pour matcher "9 notes - Débutant" etc.
      var notesDigit = targetNotes ? (String(targetNotes).match(/\d+/) || [''])[0] : '';
      var hzDigit    = targetHz    ? (String(targetHz).match(/\d+/) || [''])[0] : '';

      var notesPatterns = targetNotes ? [
        new RegExp('^\\s*' + String(targetNotes).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'i'),
        notesDigit ? new RegExp('^\\s*' + notesDigit + '\\s*notes?\\b', 'i') : /^$/,
        notesDigit ? new RegExp('^\\s*' + notesDigit + '\\b', 'i') : /^$/
      ] : null;
      var hzPatterns = targetHz ? [
        new RegExp('^\\s*' + String(targetHz).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'i'),
        hzDigit ? new RegExp('^\\s*' + hzDigit + '\\s*hz\\b', 'i') : /^$/,
        hzDigit ? new RegExp('^\\s*' + hzDigit + '\\b', 'i') : /^$/
      ] : null;

      function matchAny(val, patterns) {
        if (val == null || !patterns) return false;
        var s = String(val);
        for (var i = 0; i < patterns.length; i++) if (patterns[i].test(s)) return true;
        return false;
      }

      var lastChanged = null;
      var changed = false;

      root.querySelectorAll('.variant-picker__option').forEach(function(opt) {
        var nameEl = opt.querySelector('.variant-picker__option-name span, .variant-picker__option-name');
        var optionName = (nameEl ? nameEl.textContent : '').toLowerCase();
        if (optionName.indexOf('couleur') !== -1 || optionName.indexOf('color') !== -1 || optionName.indexOf('colour') !== -1 || optionName.indexOf('farbe') !== -1 || optionName.indexOf('kleur') !== -1) return;
        var isNotes = /note|töne|toene|tonen/i.test(optionName);
        var isHz    = /hz|fr(é|e)quence|frequenz|frequentie/i.test(optionName);
        var patterns = isNotes ? notesPatterns : isHz ? hzPatterns : null;
        if (!patterns) return;

        var radios = opt.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          var r = radios[i];
          if (r.disabled || r.getAttribute('aria-disabled') === 'true') continue;
          if (matchAny(r.value, patterns)) {
            if (!r.checked) {
              r.checked = true;
              lastChanged = r;
              changed = true;
            }
            break;
          }
        }
      });

      if (changed && lastChanged) {
        try { lastChanged.dispatchEvent(new Event('change', { bubbles: true })); }
        catch(e) { var ev = document.createEvent('Event'); ev.initEvent('change', true, true); lastChanged.dispatchEvent(ev); }
      }
      return changed;
    }

    // Expose le helper sur le root pour que lowdesign-quiz.js puisse l'appeler.
    root.ldtSelectVariant = applyVariantSelectionByLabels;

    /* --- Audio CTA --- */
    var audioBtn = root.querySelector('[data-ldt-audio-btn]');
    var audioEl = root.querySelector('[data-ldt-audio-element]');
    var waveform = root.querySelector('[data-ldt-waveform]');
    var duration = root.querySelector('[data-ldt-audio-duration]');

    if (waveform && !waveform.children.length) {
      for (var i = 0; i < 56; i++) {
        var s = Math.sin(i * 0.7) * Math.cos(i * 0.31) * Math.sin(i * 0.13 + 1.3);
        var h = 30 + Math.abs(s) * 70;
        var bar = document.createElement('span');
        bar.className = 'bar';
        bar.style.height = h + '%';
        waveform.appendChild(bar);
      }
    }

    if (audioBtn) {
      var playing = false;
      var mockInterval = null;
      var fmtTime = function(sec) {
        if (!isFinite(sec) || sec < 0) return '0:00';
        var m = Math.floor(sec / 60);
        var s = Math.floor(sec % 60);
        return m + ':' + String(s).padStart(2, '0');
      };
      var updateBars = function(progress) {
        var bars = waveform.querySelectorAll('.bar');
        bars.forEach(function(bar, idx) { bar.classList.toggle('active', (idx / bars.length) <= progress); });
      };
      var showIcon = function(isPlaying) {
        var p = audioBtn.querySelector('[data-ldt-ico-play]');
        var pa = audioBtn.querySelector('[data-ldt-ico-pause]');
        if (p) p.hidden = isPlaying;
        if (pa) pa.hidden = !isPlaying;
      };

      if (audioEl) {
        audioEl.addEventListener('loadedmetadata', function() {
          if (audioEl.duration) duration.textContent = fmtTime(audioEl.duration);
        });
        audioEl.addEventListener('timeupdate', function() {
          if (audioEl.duration) {
            duration.textContent = fmtTime(audioEl.duration - audioEl.currentTime);
            updateBars(audioEl.currentTime / audioEl.duration);
          }
        });
        audioEl.addEventListener('ended', function() {
          playing = false; showIcon(false);
          waveform.hidden = true;
          waveform.querySelectorAll('.bar').forEach(function(b) { b.classList.remove('active'); });
        });
      }

      audioBtn.addEventListener('click', function() {
        if (!playing) {
          waveform.hidden = false;
          if (audioEl) {
            audioEl.play().catch(function() { startMock(); });
          } else { startMock(); }
          playing = true; showIcon(true);
        } else {
          if (audioEl && !audioEl.paused) audioEl.pause();
          if (mockInterval) { clearInterval(mockInterval); mockInterval = null; }
          playing = false; showIcon(false);
          waveform.hidden = true;
          waveform.querySelectorAll('.bar').forEach(function(b) { b.classList.remove('active'); });
        }
      });
      function startMock() {
        var p = 0; var total = 47;
        mockInterval = setInterval(function() {
          p += 1;
          duration.textContent = fmtTime(total - Math.floor((p / 100) * total));
          updateBars(p / 100);
          if (p >= 100) {
            clearInterval(mockInterval);
            playing = false; showIcon(false);
            waveform.hidden = true;
            waveform.querySelectorAll('.bar').forEach(function(b) { b.classList.remove('active'); });
            duration.textContent = fmtTime(total);
          }
        }, 470);
      }
    }

    /* --- Sticky CTA bas : pilote l'add-to-cart natif --- */
    var stickyEl = root.querySelector('[data-ldt-sticky]');
    var stickyBtn = root.querySelector('[data-ldt-sticky-btn]');
    var stickyLabel = root.querySelector('[data-ldt-sticky-label]');
    var stickyPrice = root.querySelector('[data-ldt-sticky-price]');
    var realAddToCartBtn = function() { return root.querySelector('[data-ref="add-to-cart-button"]'); };

    if (stickyEl && stickyBtn) {
      var formWrapper = root.querySelector('.ldt-form-wrapper');
      if (formWrapper && 'IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function(entries) {
          entries.forEach(function(e) { stickyEl.hidden = e.isIntersecting; });
        }, { threshold: 0, rootMargin: '0px 0px -100px 0px' });
        obs.observe(formWrapper);
      }

      stickyBtn.addEventListener('click', function() {
        var btn = realAddToCartBtn();
        if (btn && !btn.disabled) {
          btn.click();
        } else {
          var target = root.querySelector('.ldt-form-wrapper');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      var syncSticky = function() {
        var btn = realAddToCartBtn();
        if (!btn) return;
        stickyBtn.disabled = btn.disabled;
        var txt = btn.querySelector('.full-add-to-cart-text');
        if (txt && stickyLabel) stickyLabel.textContent = txt.textContent.trim() || 'Ajouter au panier';
      };
      syncSticky();
      var ctaWrapper = root.querySelector('.ldt-cta-wrapper');
      if (ctaWrapper && 'MutationObserver' in window) {
        var mo = new MutationObserver(function() { syncSticky(); });
        mo.observe(ctaWrapper, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      }
    }

    /* ====================================================================
       Prix LowDesign — version simple, pas de combat avec Fullstack
       Les prix sont DÉJÀ formatés côté Liquid (price_money, compare_money,
       saving_money). On lit la variante courante, on écrit, c'est tout.
       Une seule update par changement de variante.
       ==================================================================== */
    var ldtPriceCurrent = root.querySelector('[data-ldt-price-current]');
    var ldtPriceOld = root.querySelector('[data-ldt-price-old]');
    var ldtPriceSave = root.querySelector('[data-ldt-price-save]');

    /* FIX 1 — Custom pricing inside ATC button (résistant à Kaching Bundles) */
    function ensureCustomCtaPricing(variant) {
      if (!variant) return;
      // Sélecteurs spécifiques d'abord (évite les boutons +/- du quantity selector qui ont aussi .button)
      var btn = root.querySelector('.ldt-cta-wrapper button[name="add"]')
             || root.querySelector('.ldt-cta-wrapper [data-ref="add-to-cart-button"]')
             || root.querySelector('.ldt-cta-wrapper button[type="submit"]')
             || root.querySelector('.ldt-cta-wrapper .product-add-to-cart-button > button');
      if (!btn) return;

      // Le contenu visible de Fullstack est dans .button__content (frère du séparateur et du prix)
      var contentHost = btn.querySelector('.button__content') || btn;

      var custom = contentHost.querySelector('.ldt-cta-pricing');
      if (!custom) {
        custom = document.createElement('span');
        custom.className = 'ldt-cta-pricing';
        custom.setAttribute('data-ldt-cta-pricing', '');
        custom.innerHTML =
          '<span class="ldt-cta-price-now" data-ldt-cta-now></span>' +
          '<span class="ldt-cta-price-old" data-ldt-cta-old></span>';
        contentHost.appendChild(custom);
      }

      var nowEl = custom.querySelector('[data-ldt-cta-now]');
      var oldEl = custom.querySelector('[data-ldt-cta-old]');
      if (nowEl && variant.price_money && nowEl.textContent !== variant.price_money) {
        nowEl.textContent = variant.price_money;
      }
      if (oldEl) {
        var wantOld = variant.compare_money || '';
        if (oldEl.textContent !== wantOld) oldEl.textContent = wantOld;
        oldEl.hidden = !wantOld;
      }
    }

    /* Détection variante : lit les radios COCHÉS dans le variant-picker.
       On évite l'URL et l'input[name=id] qui ne sont pas synchrones avec le clic
       quand le produit a plusieurs options (notes + fréquence + couleur). */
    function getSelectedVariant() {
      if (!variantsData || !variantsData.length) return null;

      // 1. Source la plus fiable : valeurs des radios cochés
      var checkedValues = [];
      root.querySelectorAll('.variant-picker__option').forEach(function(opt) {
        var checked = opt.querySelector('input[type="radio"]:checked');
        if (checked) checkedValues.push(checked.value.trim());
      });
      // Variante avec selects (pas radios) — fallback sur les <select>
      if (!checkedValues.length) {
        root.querySelectorAll('.variant-picker__option select').forEach(function(sel) {
          if (sel.value) checkedValues.push(String(sel.value).trim());
        });
      }

      if (checkedValues.length > 0) {
        // Match : toutes les valeurs cochées doivent être dans variant.options
        // (ordre indépendant — robuste aux différences d'ordre Shopify)
        var match = variantsData.find(function(v) {
          if (!v.options || v.options.length !== checkedValues.length) return false;
          for (var i = 0; i < checkedValues.length; i++) {
            if (v.options.indexOf(checkedValues[i]) === -1) return false;
          }
          return true;
        });
        if (match) return match;
      }

      // 2. Fallback URL ?variant= (si Fullstack l'a quand même mis à jour)
      try {
        var params = new URLSearchParams(window.location.search);
        var fromUrl = params.get('variant');
        if (fromUrl) {
          var foundUrl = variantsData.find(function(v) { return v.id === parseInt(fromUrl, 10); });
          if (foundUrl) return foundUrl;
        }
      } catch(e) {}

      // 3. Fallback hidden input
      var idInput = root.querySelector('input[name="id"]');
      if (idInput && idInput.value) {
        var foundInput = variantsData.find(function(v) { return v.id === parseInt(idInput.value, 10); });
        if (foundInput) return foundInput;
      }

      // 4. Dernier recours : 1ère variante
      return variantsData[0];
    }

    /* FIX 2 (09/10/2026) — Ajout au panier de la version choisie.
       Le bouton « Ajouter au panier » a son propre champ caché name="id" qui garde
       la version du chargement de la page, et Kaching Bundles ne voit pas le
       changement (il surveille un champ que le variant-picker remplace).
       Résultat avant correctif : le panier recevait toujours la version par défaut.
       On recopie la version choisie dans les champs id de la fiche et dans l'URL
       (?variant=), que Kaching écoute. Sans ?variant= au départ, l'URL ne change
       que si le client choisit une autre version. */
    var ldtInitialVariant = getSelectedVariant();
    var ldtInitialVariantId = ldtInitialVariant ? String(ldtInitialVariant.id) : null;
    function syncVariantForCart(variant) {
      if (!variant || !variant.id) return;
      var want = String(variant.id);
      root.querySelectorAll('input[name="id"]').forEach(function(input) {
        if (input.value !== want) input.value = want;
      });
      try {
        var url = new URL(window.location.href);
        var current = url.searchParams.get('variant');
        if (current === want) return;
        if (!current && want === ldtInitialVariantId) return;
        url.searchParams.set('variant', want);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {}
    }

    function updateLdtPrice() {
      var variant = getSelectedVariant();
      if (!variant) return;

      syncVariantForCart(variant);

      /* ============ ZONE 1 : Prix du HAUT (.ldt-price-row) ============ */
      if (ldtPriceCurrent && variant.price_money) {
        ldtPriceCurrent.textContent = variant.price_money;
      }
      if (ldtPriceOld) {
        if (variant.compare_money) {
          ldtPriceOld.textContent = variant.compare_money;
          ldtPriceOld.hidden = false;
        } else {
          ldtPriceOld.hidden = true;
        }
      }
      if (ldtPriceSave) {
        if (variant.saving_money) {
          ldtPriceSave.textContent = '−' + variant.saving_money;
          ldtPriceSave.hidden = false;
        } else {
          ldtPriceSave.hidden = true;
        }
      }

      /* ============ ZONE 2 : STICKY CTA (en bas) ============ */
      if (stickyPrice && variant.price_money) {
        stickyPrice.textContent = variant.price_money;
      }
      var stickyStrike = root.querySelector('.ldt-sticky-strike');
      if (stickyStrike && variant.compare_money) {
        stickyStrike.textContent = variant.compare_money;
      }

      /* ============ ZONE 3 : BOUTON natif "Ajouter au panier" (Fullstack + Kaching) ============
         FIX 1 — Stratégie : Kaching Bundles écrase les éléments natifs
         [data-ref="price"] et [data-ref="compare-at-price"] avec la somme
         du bundle (€1.133,00). On ne peut pas gagner cette course.
         Solution : on masque les éléments natifs via CSS (cf. lowdesign-top.css)
         et on injecte un span .ldt-cta-pricing contrôlé par nous.
         Le span est ré-injecté à chaque mutation du wrapper pour résister
         à un éventuel re-render Kaching. */
      ensureCustomCtaPricing(variant);

      /* ============ ZONE 4 : BUNDLE — handpan principal (.lde-bundle-section) ============ */
      // Cette section est en dehors de .lowdesign-top, donc on requête sur document.
      document.querySelectorAll('.lde-bundle-item').forEach(function(item){
        var newEl = item.querySelector('.lde-bundle-new');
        if (!newEl) return;
        // Le main item est celui sans la classe .lde-bundle-free (les addons sont "Inclus" en libre)
        if (!newEl.classList.contains('lde-bundle-free')) {
          if (variant.price_money) newEl.textContent = variant.price_money;
          var oldEl = item.querySelector('.lde-bundle-old');
          if (oldEl) {
            if (variant.compare_money) {
              oldEl.textContent = variant.compare_money;
              oldEl.style.display = '';
            } else {
              oldEl.textContent = '';
              oldEl.style.display = 'none';
            }
          }
        }
      });

      /* ============ ZONE 5 : BUNDLE — total panier ============ */
      var bundleTotalCurrent = document.querySelector('.lde-bundle-total-current');
      if (bundleTotalCurrent && variant.price_money) {
        bundleTotalCurrent.textContent = variant.price_money;
      }
    }

    // Run initial (Liquid a déjà rendu correctement, on confirme)
    updateLdtPrice();
    // Re-run après un petit délai pour écraser tout calcul du bundle qui s'est fait juste après
    setTimeout(updateLdtPrice, 200);
    setTimeout(updateLdtPrice, 800);
    setTimeout(updateLdtPrice, 2000);

    // Run sur changement de variante (radio ou select)
    root.addEventListener('change', function(e) {
      // Petit délai pour que Fullstack mette à jour l'URL avant qu'on lise
      setTimeout(updateLdtPrice, 80);
      // Et un 2ème run plus tard pour écraser tout retour différé du bundle/Fullstack
      setTimeout(updateLdtPrice, 600);
    });

    // Run sur changement d'URL (back/forward navigateur)
    window.addEventListener('popstate', function() {
      setTimeout(updateLdtPrice, 80);
    });

    /* FIX 1 — Observer renforcé sur le wrapper CTA : si Kaching/Fullstack
       reconstruit le bouton ou mute son texte, on ré-injecte/ré-écrit
       notre span .ldt-cta-pricing. L'idempotence (test textContent !== want)
       garantit qu'on ne déclenche pas de boucle infinie. */
    var ctaWrapperForPricing = root.querySelector('.ldt-cta-wrapper');
    if (ctaWrapperForPricing && 'MutationObserver' in window) {
      var ctaMo = new MutationObserver(function() {
        var v = getSelectedVariant();
        if (v) ensureCustomCtaPricing(v);
      });
      ctaMo.observe(ctaWrapperForPricing, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  });

  /* =====================================================================
     Bundle reflow : sur desktop ≥900px, on déplace .section-lowdesign-bundle
     EN TANT QU'ENFANT direct de .lowdesign-top pour qu'il devienne un grid
     item (grid-area: bundle, colonne droite, sous le bouton Ajouter).
     Sur mobile, on remet le bundle à sa place initiale (après .lowdesign-top).
     ===================================================================== */
  (function bundleReflow(){
    var bundle = document.querySelector('.section-lowdesign-bundle');
    var topSection = document.querySelector('.lowdesign-top');
    if (!bundle || !topSection) return;

    // On garde la position initiale pour pouvoir restaurer en mobile
    var origParent = bundle.parentNode;
    var origNext = bundle.nextSibling;

    function placeBundle(){
      var isDesktop = window.matchMedia('(min-width: 900px)').matches;
      if (isDesktop) {
        if (bundle.parentNode !== topSection) {
          topSection.appendChild(bundle);
        }
      } else {
        if (bundle.parentNode === topSection && origParent) {
          if (origNext && origNext.parentNode === origParent) {
            origParent.insertBefore(bundle, origNext);
          } else {
            origParent.appendChild(bundle);
          }
        }
      }
    }

    placeBundle();
    window.addEventListener('resize', placeBundle);
    window.addEventListener('orientationchange', placeBundle);
  })();
})();